import { render } from "./CongestionLevel.vue?vue&type=template&id=a6e383a2&scoped=true&lang=pug"
import script from "./CongestionLevel.vue?vue&type=script&lang=ts"
export * from "./CongestionLevel.vue?vue&type=script&lang=ts"

import "./CongestionLevel.vue?vue&type=style&index=0&id=a6e383a2&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-a6e383a2"

export default script